<div class="px-1 aligner">
  <mat-checkbox y42StopPropagation color="primary" [formControl]="checkboxFC"> </mat-checkbox>
</div>
